import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function OurStory() {
  return <section className="py-20 md:py-28 bg-cream text-ink relative" data-id="element-419">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-420">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gold/10 relative overflow-hidden" data-id="element-421">
          {/* Decorative corner */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-[100px]" data-id="element-422"></div>

          <div className="relative z-10" data-id="element-423">
            <div className="flex items-center gap-4 mb-8" data-id="element-424">
              <Heart className="w-8 h-8 text-gold fill-gold/20" data-id="element-425" />
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal" data-id="element-426">
                Por qué hacemos esto
              </h2>
            </div>

            <div className="space-y-6 text-lg md:text-xl font-light leading-relaxed text-charcoal/90" data-id="element-427">
              <p data-id="element-428">
                Somos una compañía creada para y por la comunidad hispana en
                Estados Unidos.
              </p>

              <p data-id="element-429">
                Sabemos lo que significa organizar un evento con el corazón
                puesto en cada detalle. Sabemos el sacrificio detrás de cada
                quinceañera, cada boda, cada graduación.
              </p>

              <div className="py-6 text-center" data-id="element-430">
                <p className="font-script text-4xl md:text-5xl text-gold-dark" data-id="element-431">
                  "Porque nosotros también somos familia."
                </p>
              </div>

              <p data-id="element-432">
                Hemos tenido el honor de ser parte de bodas llenas de mariachi y
                globos dorados. De quinceañeras donde la mamá lloró desde el
                primer vals hasta el último. De graduaciones donde el papá — que
                cruzó fronteras para darle una mejor vida a su hijo — no podía
                contener el orgullo.
              </p>

              <p className="font-medium text-charcoal pt-4" data-id="element-433">
                Y en cada uno de esos eventos, vimos algo que nos movió
                profundamente:
              </p>

              <p className="text-xl md:text-2xl font-serif text-gold-dark italic" data-id="element-434">
                Los momentos más hermosos pasaban en frente de nuestro espejo.
              </p>

              <p data-id="element-435">
                El abrazo entre la novia y su abuela. El baile improvisado entre
                primos. La foto seria del quinceañero rodeado de su familia.
              </p>

              <p className="font-medium pt-4" data-id="element-436">
                Esos momentos son los que nos hacen hacer lo que hacemos.
              </p>

              <p className="font-script text-3xl text-charcoal pt-2" data-id="element-437">
                Con cariño, dedicación y orgullo de nuestra raíces.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}